// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-e5512fbc] {\n  display: flex;\n}\n.el-row[data-v-e5512fbc] {\n  margin: 0 !important;\n}\n[data-v-e5512fbc] .el-form-item__label {\n  width: 125px;\n}\n[data-v-e5512fbc] .el-form-item__content {\n  flex: 1;\n}\n[data-v-e5512fbc] .el-textarea__inner {\n  height: 80px;\n}\n.el-col[data-v-e5512fbc] {\n  padding: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
